module.exports = __webpack_public_path__ + "static/media/big-cash-vouchar.4d877859.png";